enum StatusDateType {
    REQAPPROVED = 'REQAPPROVED',
    WAPPROVE = 'WAPPROVE',
    POSTPONED = 'POSTPONED',
    SHIPTOREAPPROVE = 'SHIPTOREAPPROVE',
}

export default StatusDateType;